import { t } from '@lingui/core/macro';

export const translateUploadError = (error: {
  code: string;
  detail: string;
}): string => {
  if (error.code === 'DuplicateDocumentError') {
    return t`The submitted document already exists.`;
  }
  return error.detail;
};
